import { SET_LOCALIZATION_STRING } from './actionTypes';

// @TODO improve
export function setLocalizationString(localizationString) {
  return {
    type: SET_LOCALIZATION_STRING,
    payload: localizationString
  };
}



// WEBPACK FOOTER //
// ./src/store/reducers/localizationString/actions.js